import { useMutation, useQuery } from "@tanstack/react-query";
import { AssignContent, assignContentToPatients, educationMetrics, generateEducationContent, getEducationContents, getPatientAssignments } from "../../api/education/educationApi";
import { queryClient } from "../../../lib/query";


export const useGenerateEducationContent = () => {
    
    return useMutation({
        mutationKey: ["generate-education-content"],
        mutationFn: async (payload: {
            content_topic: string;
            content_type: string;
            category: string;
            language: string;
            additional_instructions: string;
        }) => {
            const response = await generateEducationContent(payload);
            return response;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['education-contents'], exact: false });
        },
        onError: (error: unknown) => {
            console.error('Failed to generate education content:', error);
        },
    });
    
};

export const useGetEducationContents = (params: Partial<Parameters<typeof getEducationContents>[0]>) => {
    
    return useQuery({
        queryKey: ['education-contents', params],
        queryFn: async () => {
            const response = await getEducationContents(
                params as Parameters<typeof getEducationContents>[0]
            );
            return response;
        },
    });
    
};

export const useAssignContentToPatients = (payload: AssignContent) => {
    
    return useMutation({
        mutationKey: ["assign-content-to-patients"],
        mutationFn: async () => {
            const response = await assignContentToPatients(payload);
            return response;
        },
        onError: (error: unknown) => {
            console.error('Failed to assign content to patients:', error);
        },
    });
    
};

export const useGetPatientAssignments = (params: Partial<Parameters<typeof getPatientAssignments>[0]>) => {

    return useQuery({
        queryKey: ['patient-assignments', params],
        queryFn: async () => {
            const response = await getPatientAssignments(
                params as Parameters<typeof getPatientAssignments>[0]
            );
            return response;
        },
    });

};

export const useGetEducationMetrics = () => {
    return useQuery({
        queryKey: ['education-metrics'],
        queryFn: async () => {
            const response = await educationMetrics();
            return response;
        },
    });
};
